import { Order } from '../../../store/orders/types'

// Helper function that fetches the scheduled call time for a call
export default function (order: Order): string {
  // @TODO Pull this from the order itself
  return '<span class="placeholder">{day}</span> at <span class="placeholder">{time}</span>'
}
